import React, { Component } from 'react'
import { db } from "../services/firebase"

import style from "./MessageBox.module.css"

import Message from "./Message";
import Snackbar from '@material-ui/core/Snackbar'
import Alert from "@material-ui/lab/Alert"

export default class MessageBox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            chats: [],
            error: "null"
        }
    }

    fetchChatData = async () => {
        this.setState({
            error: null
        })
        try {
            db.ref("chat").on("value", snapshot => {
                if (snapshot.val() === null) {
                    // If snapshot is empty
                    this.setState({ chats: [] })
                } else {
                    const chats = []
                    for (let [key, value] of Object.entries(snapshot.val())) {
                        chats.push({ id: key, ...value })
                    }
                    this.setState({ chats })
                    this.setState({ error: null })
                }
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    async componentDidMount() {
        await this.fetchChatData()
    }

    render() {
        return (
            <div className={style.messageBox}>
                {this.state.chats.map(c => (
                    <Message key={c.id} email={c.email} content={c.content} timestamp={c.timestamp} />
                ))}
                <Snackbar open={this.state.error !== null} autoHideDuration={2000} onClose={() => { this.setState({ error: null }) }}>
                    <Alert onClose={() => { this.setState({ error: null }) }} severity="error">
                        {this.state.error}
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}
